<dx-popup [title]="title"
          [visible]="isVisible"
          [shading]="true"
          [resizeEnabled]="false"
          [closeOnOutsideClick]="false"
          (onHiding)="cancelRequest()">
  <form id="incidentForm" (submit)="submitIncident($event)">
    <dx-scroll-view #scrollView [height]="getContentHeight()" [direction]="'both'" [useNative]="true">
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'General' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label">{{'STMID' | translate}}</div>
              <dx-text-box [(value)]="incident.STMID" [readOnly]="true"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'ESTMID' | translate}}</div>
              <dx-text-box [(value)]="incident.ESTMID"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Source' | translate}}</div>
              <dx-select-box [items]="sources" [(value)]="incident.Source"></dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Created Date' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="incident.CreatedDate"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'User ID' | translate}}</div>
              <dx-text-box [(value)]="incident.UserName" [readOnly]="true"></dx-text-box>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Division' | translate}}</div>
              <dx-select-box [dataSource]="divisions" [displayExpr]="'Name'" [valueExpr]="'Name'"
                             [(value)]="incident.Division" [disabled]="true"></dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Classification' | translate}}</div>
              <dx-select-box [items]="classifications" [(value)]="incident.Classification"></dx-select-box>
            </div>
            <div class="grid-row" *ngIf="incident.Division?.toUpperCase() === 'GAS'">
              <div class="label">{{'Has Gas Detected' | translate}}</div>
              <dx-check-box [(value)]="incident.HasGasDetected"></dx-check-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Is Emergency' | translate}}</div>
              <dx-check-box [(value)]="incident.IsEmergency"></dx-check-box>
            </div>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Reporter Data' | translate }}</div>
        <div class="grid-fieldset before-remark">
          <div>
            <div class="grid-row">
              <div class="label">{{'Reporter Name' | translate}}</div>
              <div>
                <dx-validation-group #validationGroupReporterName>
                  <dx-text-box [(value)]="incident.ReporterName">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="{{'Reporter Name is required!' | translate}}"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </dx-validation-group>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter Surname' | translate}}</div>
              <div>
                <dx-validation-group #validationGroupReporterSurname>
                  <dx-text-box [(value)]="incident.ReporterSurname">
                    <dx-validator>
                      <dxi-validation-rule type="required"
                                           message="{{'Reporter Surname is required!' | translate}}"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </dx-validation-group>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter Postal Code' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter postal code...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="incident.ReporterPostalCode"
                                 [dataSource]="reporterPostalCodes"
                                 [searchMode]="'startswith'"
                                 (onValueChanged)="onReporterPostalCodeChanged($event)"></dx-autocomplete>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter City' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter city...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="incident.ReporterCity"
                                 [dataSource]="reporterCities"
                                 [searchMode]="'startswith'"
                                 (onValueChanged)="onReporterCityChanged($event)"></dx-autocomplete>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter Street' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter street...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="incident.ReporterStreet"
                                 [dataSource]="reporterStreets"
                                 [searchMode]="'startswith'"
                                 (onValueChanged)="onReporterStreetChanged($event)"></dx-autocomplete>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter House No.' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter house number...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="incident.ReporterHouseNo"
                                 [dataSource]="reporterHouseNos"
                                 [searchMode]="'startswith'"></dx-autocomplete>
              </div>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Reporter Phone' | translate}}</div>
              <dx-text-box [(value)]="incident.ReporterPhone"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter City Part' | translate}}</div>
              <dx-autocomplete [(value)]="incident.ReporterCityPart"
                               [valueChangeEvent]="'blur'"
                               [dataSource]="reporterCityParts"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
        </div>
        <div class="remark">
          <div class="label">{{'Reporter Remarks' | translate}}</div>
          <dx-text-area [(value)]="incident.ReporterRemarks" [height]="90"></dx-text-area>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Incident Location' | translate }}</div>
        <div class="grid-fieldset before-remark">
          <div>
            <div class="grid-row">
              <div class="label">{{'Incident Name' | translate}}</div>
              <dx-text-box [(value)]="incident.IncidentName"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident Surname' | translate}}</div>
              <dx-text-box [(value)]="incident.IncidentSurname"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident Postal Code' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter postal code...' | translate}}"
                               [(value)]="incident.IncidentPostalCode"
                               [dataSource]="incidentPostalCodes"
                               [searchMode]="'startswith'"
                               (onValueChanged)="onIncidentPostalCodeChanged($event)"></dx-autocomplete>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident City' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter city...' | translate}}"
                               [(value)]="incident.IncidentCity"
                               [dataSource]="incidentCities"
                               [searchMode]="'startswith'"
                               (onValueChanged)="onIncidentCityChanged($event)"></dx-autocomplete>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident Street' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter street...' | translate}}"
                               [(value)]="incident.IncidentStreet"
                               [dataSource]="incidentStreets"
                               [searchMode]="'startswith'"
                               (onValueChanged)="onIncidentStreetChanged($event)"></dx-autocomplete>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident House No.' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter house number...' | translate}}"
                               [(value)]="incident.IncidentHouseNo"
                               [dataSource]="incidentHouseNos"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Incident Phone' | translate}}</div>
              <dx-text-box [(value)]="incident.IncidentPhone"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident City Part' | translate}}</div>
              <dx-autocomplete [(value)]="incident.IncidentCityPart"
                               [dataSource]="incidentCityParts"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
        </div>
        <div class="remark">
          <div class="label">{{'Incident Remarks' | translate}}</div>
          <dx-text-area [(value)]="incident.IncidentRemarks" [height]="90"></dx-text-area>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Location' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label">{{'Location' | translate}}</div>
              <dx-autocomplete [(value)]="incident.Location"
                               [dataSource]="locations"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Civil Engineer' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label">{{'Civil Engineer Name' | translate}}</div>
              <dx-text-box [(value)]="incident.CivilEngineerName"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Civil Engineer Informed' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="incident.CivilEngineerInformed"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
          </div>
          <div>
            <div style="height: 46px">

            </div>
            <div class="grid-row">
              <div class="label">{{'Civil Engineer Arrival' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="incident.CivilEngineerArrival"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Process Tracking' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label break-space">{{'Initial Safeguarding Measures were read out' | translate}}</div>
              <dx-check-box [(value)]="incident.InitialSafeguardingMeasures"></dx-check-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Damage Code' | translate}}</div>
              <dx-select-box [displayExpr]="'Code'"
                             [valueExpr]="'Code'"
                             [(value)]="incident.DamageCode"
                             [dataSource]="damageTypes"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Damage Reason Code' | translate}}</div>
              <dx-select-box [displayExpr]="'Code'"
                             [valueExpr]="'Code'"
                             [(value)]="incident.DamageReasonCode"
                             [dataSource]="damageReasons"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Forwarded' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="incident.Forwarded"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Process Started' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="incident.ProcessStarted"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Arrival Time' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="incident.ArrivalTime"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Incident State' | translate}}</div>
              <dx-select-box [items]="incidentStates" [(value)]="incident.IncidentState"></dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Description' | translate}}</div>
              <dx-select-box [displayExpr]="'Description'"
                             [valueExpr]="'Code'"
                             [(value)]="incident.DamageCode"
                             [dataSource]="damageTypes"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Description' | translate}}</div>
              <dx-select-box [displayExpr]="'Description'"
                             [valueExpr]="'Code'"
                             [(value)]="incident.DamageReasonCode"
                             [dataSource]="damageReasons"
                             [searchEnabled]="true">
              </dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Response Group' | translate}}</div>
              <dx-text-box [(value)]="incident.ResponseGroup"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Process Owner' | translate}}</div>
              <dx-text-box [(value)]="incident.ProcessOwner"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Departure Time' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'"
                           [(value)]="incident.DepartureTime" (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
          </div>
        </div>
      </div>
      <app-file-management [rowKey]="incident?.IncidentKey"></app-file-management>
    </dx-scroll-view>
    <div class="footer">
      <div>
        <dx-button id="btnReference" text="{{'Add reference to Report' | translate}}" type="success"
                   (click)="referenceReport()"></dx-button>
      </div>
      <div class="right-buttons">
        <dx-button id="btnSave" text="{{'Save' | translate}}" type="success" [useSubmitBehavior]="true"></dx-button>
        <dx-button id="btnCancel" text="{{'Cancel' | translate}}" type="default" (click)="cancelRequest()"></dx-button>
      </div>
    </div>
  </form>
</dx-popup>
